import MemoryType from "../../../service/memory/enum/MemoryType";

export const clearLocalStorage = () => {
  const preserveValue = localStorage.getItem(MemoryType.CHALLENGE);

  localStorage.clear();
  if (preserveValue !== null) {
    localStorage.setItem(MemoryType.CHALLENGE, preserveValue);
  }
};
